import React from 'react';
import { motion } from 'framer-motion';

const Contact: React.FC = () => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="max-w-xl mx-auto py-12 px-4 text-center text-white"
  >
    <h1 className="text-4xl font-bold mb-8 text-accent">Contact Us</h1>
    <p className="text-lg mb-6">Have questions, feedback, or want to get involved?</p>
    
    <div className="bg-black/30 p-6 rounded-lg border border-fiesta-blue/20 shadow-lg mb-8">
      <div className="flex flex-col space-y-4">
        <a 
          href="mailto:info@fantasy-fiesta.com" 
          className="text-primary hover:text-primary/80 transition-colors flex items-center justify-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="text-lg font-medium underline">info@fantasy-fiesta.com</span>
        </a>
      </div>
    </div>
    
    <p className="text-fiesta-blue/80 text-sm">We'll get back to you as soon as possible!</p>
  </motion.div>
);

export default Contact;
